import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { InterceptorHelperService } from '../services/interceptor-helper.service';
import { RouterFacadeService } from '../store/router/router-facade.service';

export const requestContextInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const appConfigService = inject(AppConfigService);
  const interceptorHelperService = inject(InterceptorHelperService);
  const router = inject(Router);
  const routerFacadeService = inject(RouterFacadeService);

  const baseUrl = appConfigService.appConfig.azure.proxy_base_url;

  const isAdminRoute = router.url.includes('admin');
  const isNotApiRequest = !request.url.includes(baseUrl);
  const hasCVRequestContextHeader = request.headers.has('CV-Request-Context');

  if (isAdminRoute || isNotApiRequest || hasCVRequestContextHeader) {
    return next(request);
  }

  const requestParamsTenantId = request.params.get('organisationId');
  const requestParamsBoardId = request.params.get('boardId');
  const routerTenantId = routerFacadeService.tenantId();
  const routerBoardId = routerFacadeService.boardId();
  const interceptorHelperTenantId = interceptorHelperService.selectedTenantId();
  const interceptorHelperBoardId = interceptorHelperService.selectedBoardId();
  const interceptorHelperServiceProviderId = interceptorHelperService.selectedServiceProviderId();

  const tenantId = requestParamsTenantId || routerTenantId || interceptorHelperTenantId;
  const boardId = requestParamsBoardId || routerBoardId || interceptorHelperBoardId;
  const serviceProviderId = interceptorHelperServiceProviderId;

  const tenantIdForHeader = tenantId?.replace(/-/g, '') || '*';
  const boardIdForHeader = boardId?.replace(/-/g, '') || '*';
  const serviceProviderIdForHeader = serviceProviderId?.replace(/-/g, '') || '*';

  const headerValue = `01-${serviceProviderIdForHeader}-${tenantIdForHeader}-${boardIdForHeader}-*-*`;

  const modifiedRequest = request.clone({ setHeaders: { 'CV-Request-Context': headerValue } });

  return next(modifiedRequest);
};
